"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.SENTRY = exports.ERRORS = void 0;
var ERRORS = {
  ERROR_CODES: 'errorCodes',
  DEFAULT_ERROR_CODE: 'Something went wrong please try again',
  ON_LOAD_ERROR: 'errors_onload',
  RESPONSE_STATUS_TYPE_REF: 'https://www.w3.org/Protocols/rfc2616/rfc2616-sec10.html'
};
exports.ERRORS = ERRORS;
var SENTRY = {
  DSN: {
    DESKTOP: 'https://ccfd7a6eb88745c098eb8997b8847e8c@sentry.io/1407024',
    MWEB: 'https://507b0e54bef44ae3810a13231a359810@sentry.io/1445426',
    HOME: 'https://2ff2de4309df431d826f92213fd06fc0@sentry.io/1446253',
    FLIGHTS: 'https://3ebc3a8be84e49489a46e0a0faf2004c@sentry.io/1446263',
    PAYMENT: 'https://3b6ef80134df4e38882690e39509f45f@sentry.io/1446265'
  },
  VERTICAL: {
    HOME: 'HOME',
    FLIGHT: 'FLIGHT',
    HOTEL: 'HOTEL',
    PAYMENT: 'PAYMENT',
    MWEB: 'MWEB'
  }
};
exports.SENTRY = SENTRY;
var _default = {
  ENDPOINTS: {
    CURRENCY_LIST: '/api/system/currency/list',
    COUNTRY_LIST: '/api/system/country/list',
    INSURANCE_PLANS: '/api/insurance/plan',
    APPLY_INSURANCE: '/api/insurance/cart',
    REMOVE_INSURANCE_PLAN: '/api/insurance/cart/{cartId}/product/{productId}',
    TOKEN_VISA_URL: '/api/payment-api/card/visa-checkout',
    CHECK_PAYMENT_3D_SECURE: '/api/check-payment-3ds?_c={pollingCount}&_t={pollingStartTime}',
    CMS_PAGE: '/api/cms/page',
    CMS_PAGE_NO_CACHE: '/api/cms/page?no-cache=true',
    SUB_NEWSLETTER: '/api/account/newsletter/subscribe'
  },
  ERRORS: ERRORS,
  SENTRY: SENTRY,
  EVENTS: {
    APP_ERROR: 'app-error'
  },
  PAYMENT: {
    PROVIDER: 'checkoutcom'
  },
  CURRENCY: {
    BASE_NAME: 'Saudi Riyal',
    BASE_NAME_PLURAL: 'Saudi Riyal',
    BASE_SYMBOL: 'SAR',
    DEFAULT_ROUNDING: 0,
    DEFAULT_DECIMAL_DIGITS: 2
  },
  THREE_D_SECURE_POLLING_MAX_COUNT: 60,
  STORAGE_KEYS: {
    AUTH_TOKEN: 'token',
    CURRENCY_LIST: 'CURRENCY_LIST',
    CURRENCY: 'currency',
    LANGUAGE: 'language'
  },
  CONNECTION_STATUS: {
    ONLINE: 'online',
    OFFLINE: 'offline'
  },
  BRANDS: {
    TAJAWAL: 'tajawal',
    ALMOSAFER: 'almosafer'
  },
  BRANDS_PREFIX: {
    TAJAWAL: 'TJ',
    ALMOSAFER: 'AM'
  },
  ENV: {
    LOCAL: 'local',
    DEV: 'dev',
    LIVE: 'live'
  },
  LOCALES: {
    EN: 'en-us',
    AR: 'ar-sa'
  },
  LANGUAGE: {
    EN: 'en',
    AR: 'ar'
  },
  DOMAINS: {
    TJ_LIVE_COM: 'liveCom',
    TJ_LIVE_SA: 'liveSa',
    TJ_DEV_SA: 'devSa',
    TJ_DEV_COM: 'devCom',
    TJ_LIVE_BH: 'liveBh',
    TJ_DEV_BH: 'devBh',
    TJ_LIVE_AE: 'liveAe',
    TJ_DEV_AE: 'devAe',
    TJ_LIVE_KW: 'liveComKw',
    TJ_DEV_KW: 'devComKw',
    AM_LIVE_COM: 'liveMoCom',
    AM_DEV_COM: 'devMoCom',
    AM_LIVE_EG: 'liveMoEg',
    AM_DEV_EG: 'devMoEg',
    AM_LIVE_AE: 'liveMoAe',
    AM_DEV_AE: 'devMoAe',
    AM_LIVE_KW: 'liveMoKw',
    AM_DEV_KW: 'devMoKw',
    AM_LIVE_BH: 'liveMoBh',
    AM_DEV_BH: 'devMoBh',
    AM_LIVE_Global: 'liveMoGlobal',
    AM_DEV_Global: 'devMoGlobal'
  },
  EMAILS: {
    TJ_SUPPORT: 'support@tajawal.com',
    AM_SUPPORT: 'support@almosafer.com',
    AM_FLIGHTS_SUPPORT: 'flightsupport@almosafer.com'
  },
  CREDIT_CARDS: {
    VISA: 'visa',
    MASTER_CARD: 'master-card',
    AMERICAN_EXPRESS: 'american-express',
    MADA: 'mada',
    QITAF: 'QITAF',
    KNET: 'KNET'
  },
  APP_EVENTS: {
    FLIGHTS: {
      FLIGHT_SEARCH: 'flight.search',
      FLIGHT_MODIFY_SEARCH: 'flight.modify-search',
      FLIGHT_SEARCH_DETAIL: 'flight.search-details',
      FLIGHT_RESULTS: 'flight.results',
      FLIGHT_SELECT: 'flight.select',
      FLIGHT_DETAILS: 'flight.details',
      FLIGHT_BOOKING: 'flight.booking'
    },
    HOTELS: {
      HOTEL_SEARCH: 'hotel.search',
      HOTEL_SELECT: 'hotel.select',
      HOTEL_SEARCH_DETAIL: 'hotel.search-details',
      HOTEL_SEARCH_SELECT: 'hotel.search-select',
      HOTEL_RESULTS: 'hotel.results',
      HOTEL_BOOKING: 'hotel.booking'
    }
  }
};
exports["default"] = _default;